import { Component } from '@angular/core';
import { UiActionsService } from './services/ui-actions.service';

import * as $ from "jquery";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  public constructor(private uiActions: UiActionsService) { }

  public onClick(): void {
    if (this.uiActions.DraggingExchange) {
      //If we received the click event, it was outside a slot where the exchange thumbnail being dragged can
      //be dropped => cancel the reposition
      this.uiActions.draggingFinished();
    }
  }
}
